import { getRequest } from "../../services/Requests";

export enum MANAGEMENT_ACTIONS {
  FETCH_FAILED = "FETCH_FAILED",
  FETCH_PENDING = "FETCH_PENDING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
}

export const fetchFailed = (payload) => ({
  type: MANAGEMENT_ACTIONS.FETCH_FAILED,
  payload,
});

export const fetchPending = () => ({
  type: MANAGEMENT_ACTIONS.FETCH_PENDING,
});

export const setData = (payload) => ({
  type: MANAGEMENT_ACTIONS.FETCH_SUCCESS,
  payload,
});

export const fetchData = () => async (dispatch) => {
    dispatch(fetchPending());
    try {
      const response = await getRequest({
        url: "management",
      });
      const {
          data = {},
      } = response;
      dispatch(setData(data));
    } catch (error) {
      dispatch(fetchFailed("unkownerror"));
    }
};
